import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/marketplace_modules/lib/CollectionsBootstrap'

import { ModuleListSearchProvider } from '../components/List/ModuleListSearchProvider'

const ModulesRootPage = () => {
  return (
    <CollectionsBootstrap>
      <ModuleListSearchProvider>
        <Outlet />
      </ModuleListSearchProvider>
    </CollectionsBootstrap>
  )
}

export default ModulesRootPage
